import React from "react";
import { useTheme } from "@mui/material/styles";
import { CircularProgress, Stack } from "@mui/material";
import { DrawerHeaderStyled, LogoLink } from "./drawer-header-styled";
import { useSite } from "hooks/use-site";

const DrawerHeader: React.FC<{ open?: boolean }> = ({ open }) => {
  const { frontWalletSecondaryLogo, isSiteLoading } = useSite();
  const theme = useTheme();

  return (
    //@ts-ignore
    <DrawerHeaderStyled theme={theme} open={open}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        width={"100%"}
        justifyContent={"space-between"}
      >
        <LogoLink to={"/"}>
          {isSiteLoading && !frontWalletSecondaryLogo ? (
            <CircularProgress size={28} aria-label="Loading logo" />
          ) : frontWalletSecondaryLogo ? (
            <img
              src={frontWalletSecondaryLogo}
              alt="logo"
              height={58}
              width={260}
            />
          ) : null}
        </LogoLink>
      </Stack>
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
